export default "__VITE_ASSET__hUJMi6IC__"